import { render } from "./AssignModal.vue?vue&type=template&id=26c2c93c&scoped=true&ts=true"
import script from "./AssignModal.vue?vue&type=script&lang=ts"
export * from "./AssignModal.vue?vue&type=script&lang=ts"

import "./AssignModal.vue?vue&type=style&index=0&id=26c2c93c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c2c93c"]])

export default __exports__